/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmploymentSkills } from '../../models/employment-skills';

export interface GetEmploymentSkillById$Params {
  id: number;
}

export function getEmploymentSkillById(http: HttpClient, rootUrl: string, params: GetEmploymentSkillById$Params, context?: HttpContext): Observable<StrictHttpResponse<EmploymentSkills>> {
  const rb = new RequestBuilder(rootUrl, getEmploymentSkillById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmploymentSkills>;
    })
  );
}

getEmploymentSkillById.PATH = '/employment-skill/{id}';
